import styled from 'styled-components'

import { PreviewContent as BasePreviewContent } from '../previewStyles'

export { Container } from '../previewStyles'

export const PreviewContent = styled(BasePreviewContent)`
  background-color: ${props => props.theme.colors.background.secondary};

  /* DeliveryMethodInfo sub-components render title (1st) and message (2nd) as the first two children.
     Everything after (AddressForm, links, locations, etc.) is hidden since this is a preview-only context.
     We still pass requires_address: true so HomePickUp shows the correct copy instead of EmailPickupInstructions. */
  > div > :nth-child(n + 3) {
    display: none;
  }
`
